import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-catalog',
  templateUrl: './catalogs-catalog.component.html',
  styleUrls: ['./catalogs-catalog.component.scss']
})
export class CatalogsCatalogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
